import { AbstractDTO, SolrRequestOptionsDTO as SolrRequestOptionsGenericDTO } from "@signature-it/ngx-generic/models";
import {  GenericConfig } from "@signature-it/ngx-generic/config";
import {BehaviorSubject} from "rxjs";
import {IEsearchItem, IEsearchSortOption} from "@signature-it/ngx-entity/interfaces";

declare let _: any;

export class SearchPageData extends AbstractDTO {
    uri: string;
    productTypes: Array<string>;
    cardLayout: string;
    stats: boolean;
    statsField: string;
    kw: string;
    items: Array<IEsearchItem>;
    facets: {};
    filters: [];
    query: [];
    filtersMode: string;
    isTextFieldOutsideInput: boolean;
    paginationMode: string;
    activeFilters: {};
    totalItems: number;
    itemsPerPage: number;
    itemsPerPageSelect: Array<number>;
    page: number;
    sortOptions: Array<IEsearchSortOption>;
    sort: string;
    scroll: boolean;
    autocomplete: object;
    boxPreviewTemplateVar: string;
    linePreviewTemplateVar: string;
    responsive: {};
    fragment: string;
    pageMode: string;
    searchLayoutMode: string;
    dictionarySolrKey: string;
    showClear: boolean;
    solrQueryParams: string;
    solrQueryParamsSearch: string;
    filterTabSolrKey: string;
    focusOnSearch: string;
    spellcheck: [];
    searchItemsGrid: object;
    focusedElementId: string;
    isFocusedFirst: boolean = false;
    likeMode: string;
    public updateFocusedElement = new  BehaviorSubject(null);
    displayMode: string = "items";
    autocompleteNgram: boolean;
    searchSections: Array<object>;
    enableTaxonomySubjectSearch: boolean;
    taxonomySubjectSearchVar: string;
    redirectSearchUrl: string;
    selectedOnMenuByName: string;
    positionClose: string;
    limitParams: boolean;
    showProductPrice: boolean;
    solrTypeService:string;
    constructor(attributes?: object) {
        super(attributes);
        this.uri = attributes['uri'] || '';
        this.productTypes = attributes['productTypes'] || [];
        this.cardLayout = attributes['cardLayout'] || 'grid';
        this.items = attributes['items'] || [];
        this.filters = attributes['filters'] || [];
        this.facets = attributes['facets'] || {};
        this.query = attributes['query'] || [];
        this.filtersMode = attributes['filtersMode'] || [];
        this.isTextFieldOutsideInput = attributes['isTextFieldOutsideInput'] || false;
        this.paginationMode = attributes['paginationMode'] || [];
        this.activeFilters = attributes['activeFilters'] || {};
        this.totalItems = attributes['totalItems'] || 0;
        this.itemsPerPage = Number.parseInt(attributes['itemsPerPage']) || GenericConfig.item_per_page[0];
        this.itemsPerPageSelect = attributes['itemsPerPageSelect'] || GenericConfig.item_per_page || [];
        this.page = attributes['page'] || 1;
        this.kw = attributes['kw'] || '';
        this.statsField = attributes['statsField'] || '';
        this.sortOptions = attributes['sortOptions'] || [];
        this.sort = attributes['sort'] || '';
        this.scroll = attributes['scroll'] || false;
        this.stats = attributes['stats'] || {};
        this.autocomplete = attributes['autocomplete'] || null;
        this.linePreviewTemplateVar = attributes['linePreviewTemplateVar'] || null;
        this.boxPreviewTemplateVar = attributes['boxPreviewTemplateVar'] || null;
        this.responsive = attributes['responsive'] || null;
        this.searchLayoutMode = attributes['searchLayoutMode'] || 'tab';
        this.dictionarySolrKey = attributes['dictionarySolrKey'] || '';
        this.pageMode = attributes['pageMode'] || '';
        this.showClear = attributes['showClear'] !== undefined ? attributes['showClear'] : true;
        this.solrQueryParams = attributes['solrQueryParams'] || '';
        this.solrQueryParamsSearch = attributes['solrQueryParamsSearch'] || '';
        this.filterTabSolrKey = attributes['filterTabSolrKey'] || '';
        this.focusOnSearch = attributes['focusOnSearch'] || null;
        this.spellcheck = attributes['spellcheck'] || [];
        this.searchItemsGrid = attributes['searchItemsGrid'] || null;
        this.isFocusedFirst = attributes['isFocusedFirst'] || false;
        this.likeMode = attributes['likeMode'] || '';
        this.displayMode = attributes['displayMode'] || 'items';
        this.autocompleteNgram = attributes['autocompleteNgram'] || false;
        this.searchSections = attributes['searchSections'] || [];
        this.enableTaxonomySubjectSearch = attributes['enableTaxonomySubjectSearch'] || false;
        this.taxonomySubjectSearchVar = attributes['taxonomySubjectSearchVar'] || '';
        this.redirectSearchUrl = attributes['redirectSearchUrl'] || null;
        this.selectedOnMenuByName = attributes['selectedOnMenuByName'] || '';
        this.positionClose = attributes['positionClose'] || 'start';
        this.limitParams = attributes['limitParams'] || false;
        this.showProductPrice = attributes['showProductPrice'] || false;
        this.solrTypeService = attributes['solrTypeService'] || 'entity';
    }

    getActiveIndex() {
        return this.activeFilters[this.dictionarySolrKey];
    }

    getFocusedElement() {
        return this.items.find((item) =>  item['doc_id_s'] == this.focusedElementId);
    }

    setFocusedElement( id) {
        this.focusedElementId = id;
        this.updateFocusedElement.next(id);
    }
}
